import DownloadIcon from "@assets/images/down-arrow.svg";
import { Card, useMediaQuery } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ButtonMultiAction from "@saleor/components/ButtonMultiAction";
import Container from "@saleor/components/Container";
import Hr from "@saleor/components/Hr";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import { ListSettings } from "@saleor/types";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";
import React from "react";
import { useIntl } from "react-intl";

import { BatchesQuery_batches_edges_node } from "../../types/BatchesQuery";
import { hasSelected } from "../../utils/handlers";
import ActionButtons from "../ActionButtons";
import BatchListComponent from "../BatchList";
import PermissionSection from "../PermissionSection";

interface BatchListProps {
  batches: BatchesQuery_batches_edges_node[];
  toggle?: (data: string) => void;
  toggleAll?: any;
  isChecked?: (data: string) => void;
  numberOfColumns?: number;
  selected?: number;
  onNextPage?: () => void;
  onPreviousPage?: () => void;
  onUpdateListSettings?: (key: keyof ListSettings<any>, value: any) => void;
  pageInfo?: any;
  settings?: any;
  listElements?: string[];
  onCancelClick?: any;
  onBatchApprove: (ids?: string[] | null) => void;
  onBatchReject: (ids?: any) => void;
  openModal: (action: string, newParams?: any) => void;
}

const useStyles = makeStyles(
  () => ({
    card: {
      marginTop: "20px",
      padding: "20px"
    },
    specialistActionBtn: {
      display: "flex",
      flexDirection: "row-reverse",
      justifyContent: "space-between",
      width: "160px"
    }
  }),
  { name: "BatchList" }
);

function BatchList(props: BatchListProps) {
  const {
    onCancelClick,
    onBatchApprove,
    onBatchReject,
    openModal,
    ...batchListProps
  } = props;
  const classes = useStyles(props);
  const intl = useIntl();
  const theme = useTheme();

  const pageHeaderExpand = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Container>
      <PageHeader title={intl.formatMessage(sectionNames.batch)}>
        <PermissionSection
          userTypes={[
            SmopUserTypeCode.FINANCE_SPECIALIST,
            SmopUserTypeCode.FINANCE_MANAGER
          ]}
        >
          <></>
          <ButtonMultiAction
            actions={[
              {
                action: () => openModal("FnManagerdowloadActiveDetails"),
                disabled: hasSelected(batchListProps.selected),
                label: "Batch Download"
              },
              {
                action: () => openModal("FnManagerGeneratePayableList"),
                disabled: hasSelected(batchListProps.selected),
                label: "Generate Payables List"
              }
            ]}
            label="Download"
            placement={pageHeaderExpand ? "bottom-end" : "bottom-start"}
          />
        </PermissionSection>
      </PageHeader>

      <Card className={classes.card}>
        <PageHeader title="">
          <PermissionSection
            userTypes={[
              SmopUserTypeCode.FINANCE_SPECIALIST,
              SmopUserTypeCode.FINANCE_MANAGER
            ]}
          >
            <ActionButtons
              action={{
                negativeBtn: {
                  disabled: hasSelected(batchListProps.selected),
                  label: "Cancel",
                  onClick: onCancelClick
                },
                positiveBtn: {
                  disabled: hasSelected(batchListProps.selected),
                  icon: {
                    src: DownloadIcon,
                    type: "img"
                  },
                  onClick: () => openModal("download-active-batch"),
                  type: "icon"
                }
              }}
              className={classes.specialistActionBtn}
            />
            <ActionButtons
              action={{
                negativeBtn: {
                  disabled: hasSelected(batchListProps.selected),
                  label: "Reject",
                  onClick: () => onBatchReject(batchListProps.listElements)
                },
                positiveBtn: {
                  disabled: hasSelected(batchListProps.selected),
                  label: "Approve",
                  onClick: () => onBatchApprove(batchListProps.listElements)
                }
              }}
            />
          </PermissionSection>
        </PageHeader>
        <Hr></Hr>

        <BatchListComponent {...batchListProps} />
      </Card>
    </Container>
  );
}

export default BatchList;
